"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
/* eslint-disable no-undefined */

/**
 * useWindowSize Hook
 * @returns {Object} An object contains width and height of the window.
 */
function useWindowSize() {
  const [windowSize, setWindowSize] = (0, _react.useState)({
    width: undefined,
    height: undefined
  });
  (0, _react.useEffect)(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
}
var _default = useWindowSize;
exports.default = _default;